import styled from 'styled-components';
import { shape, string } from 'prop-types';
import { GEL_SPACING, GEL_SPACING_TRPL, GEL_MARGIN_ABOVE_400PX, GEL_MARGIN_BELOW_400PX } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_GROUP_4_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
import { getLongPrimer } from '@bbc/gel-foundations/typography';
import { C_METAL } from '@bbc/psammead-styles/colours';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { getSansRegularItalic } from '@bbc/psammead-styles/font-styles';
var Caption = /*#__PURE__*/styled.figcaption.withConfig({
  displayName: "Caption",
  componentId: "sc-16x70so-0"
})(["", ";", " color:", ";padding:", " ", " 0;width:100%;@media (min-width:", ") and (max-width:", "){padding:", " ", " 0;}@media (min-width:", "){padding:", " 0 0;}& > p{padding-bottom:", ";margin:0;}& > p:last-child{padding-bottom:0;}& i{font-style:normal;}"], function (_ref) {
  var script = _ref.script;
  return script && getLongPrimer(script);
}, function (_ref2) {
  var service = _ref2.service;
  return getSansRegularItalic(service);
}, C_METAL, GEL_SPACING, GEL_MARGIN_BELOW_400PX, GEL_GROUP_2_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_SPACING, GEL_MARGIN_ABOVE_400PX, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_SPACING, GEL_SPACING_TRPL);
Caption.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired
};
export default Caption;